module.exports = __webpack_public_path__ + "static/media/Screenshot_4.10b577cd.png";